import * as React from "react";
import { Skeleton } from "@material-ui/lab";

export const MarketResearchSupplyDemandSkeleton = () => (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Skeleton variant="rect" height={64} style={{ marginBottom: 8 }} />
        <Skeleton variant="rect" height={32} style={{ marginBottom: 8 }} />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
        <Skeleton variant="rect" height={32} style={{ marginBottom: 8 }} />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
        <Skeleton
            variant="rect"
            height={24}
            style={{ marginBottom: 8, marginLeft: 32 }}
        />
    </div>
);
